import React from 'react';
import {Button} from "react-bootstrap";
import { PhotoProvider, PhotoView } from 'react-photo-view';
import {translateRecord} from "../../../common/utils";
import {useDispatch, useSelector} from "react-redux";
import {handleDishOrderCountAction, removeOrderDishesAction} from "../../../../store/actions/OrdersActions";
import {useTranslation} from "react-i18next";

const OrderDish = ({dish, slug, fromDashboard, onEmpty, onCountChange}) => {
  const storeAuth = useSelector(store => store.auth);
  const storeOrders = useSelector(store => store.orders);
  const dispatch = useDispatch();
  const {t} = useTranslation();

  const calculateTotalPrice = (dish) => {
    let result = Object.values(dish.selectedMods).reduce((acc, mod) => {
      return acc + (Number(mod.price) * mod.quantity);
    }, 0);
    return result * parseFloat(dish.quantity);
  };

  function dishParameter(dish, param) {
    if (param === 'name') {
      return translateRecord(dish, param);
    } else if (param === 'weight') {
      return !!dish.weight ? `${dish.weight}${t(`measures.${dish['measure']}`)}` : '';
    } else {
      return dish[param];
    }
  }

  function measureUnit(dish) {
    return dish.weight_flag && !dish.selectedVariation ? t(`measures.${dish['measure']}`) : '';
  }

  function calculateCount(dish) {
    if (dish.weight_flag && !dish.selectedVariation) {
      return parseFloat(dish.weight);
    } else {
      return 1;
    }
  }

  function handleDishCount(s, dish, value) {
    const rSlug = s;
    const newQuantity = storeOrders.orderDishes[rSlug].dishes[dish.uid].quantity + value;
    let reducerDishes = {};
    if (newQuantity > (!!dish.min_order ? parseFloat(dish.min_order) - (dish.weight_flag ? parseFloat(dish.weight) : 1) : 0)) {
      reducerDishes = {
        ...storeOrders.orderDishes,
        [rSlug]: {
          ...storeOrders.orderDishes[rSlug],
          dishes: {
            ...storeOrders.orderDishes[rSlug].dishes,
            [dish.uid]: {
              ...storeOrders.orderDishes[rSlug].dishes[dish.uid],
              quantity: parseFloat(newQuantity)
            }
          }
        }
      };
      dispatch(handleDishOrderCountAction(reducerDishes, storeOrders.orderDishes[rSlug].restaurant));
      if (typeof onCountChange === 'function') {
        onCountChange();
      }
    } else {
      let dishes = storeOrders.orderDishes[rSlug].dishes;
      delete dishes[dish.uid];
      if (Object.keys(dishes).length > 0) {
        reducerDishes = {
          ...storeOrders.orderDishes,
          [rSlug]: {
            ...storeOrders.orderDishes[rSlug],
            dishes: dishes
          }
        };
        if (typeof onCountChange === 'function') {
          onCountChange();
        }
        dispatch(handleDishOrderCountAction(reducerDishes, storeOrders.orderDishes[rSlug].restaurant));
      } else {
        dispatch(removeOrderDishesAction(rSlug));
        if (typeof onEmpty === 'function') {
          onEmpty();
        }
      }
    }
  }

  return (
    <div className="order-dish d-flex justify-content-between align-items-center">
      <div className='d-flex align-items-center'>
        <Button className='order-count mr-2'
                onClick={() => handleDishCount(slug, dish, -calculateCount(dish))}
                style={{
                  color: storeAuth?.auth?.userData?.theme === 'dark' ? 'white' : '#130B01',
                  padding: '0 7.5px'
                }}
        >
          <strong>-</strong>
        </Button>
        <div>
          <h6 className='mb-0'>
            {!!dish.categoryPrice ?
              translateRecord(dish, 'category_name')
              :
              dishParameter(dish, 'name', slug)}
          </h6>
          <p className='mb-0 text-black'>
            <small>{dishParameter(dish, 'category_name')}</small>
          </p>
          <p className='mb-0 text-black'>
            <small>{dishParameter(dish, 'weight')} {!!dish.selectedVariation && `${!!dishParameter(dish, 'weight') ? '-' : ''} ${translateRecord(dish.selectedVariation, 'name')}`}</small>
          </p>
          { !dish.categoryPrice &&
            <div className='d-flex align-items-center'>
              <span className="text-primary mb-0 mr-1">
                <b>{dishParameter(dish, 'price', slug)}</b>
                <small>₴</small>
              </span>
              { dish.quantity > 1 &&
                <Button className='btn-primary' style={{ padding: '0 3px', borderRadius: '3px' }}>
                  x<strong>{dish.quantity}<small>{measureUnit(dish)}</small></strong>
                </Button>}
          </div>}
          { !!dish.selectedMods && Object.keys(dish.selectedMods).length > 0 &&
            <p className='text-muted mb-1' style={{ lineHeight: 1 }}>
              { Object.values(dish.selectedMods).map((m, i) =>
                <span key={m.id} className='mr-1' style={{ fontSize: 11 }}>
                    {dish.group_modifications[m.group_modification_id][m.id].name}
                  {m.quantity > 1 && <span className='text-primary'> x<b>{m.quantity}</b></span>}
                  {Object.keys(dish.selectedMods).length - 1 !== i && ','}
                </span>)}
              <span className='text-primary'> +<b>{calculateTotalPrice(dish)}</b><small>₴</small></span>
            </p>}
        </div>
      </div>
      <div className='d-flex align-items-center'>
        { !!dish.photo && !fromDashboard &&
          <PhotoProvider speed={() => 200}
                         easing={(type) => (type === 2 ? 'cubic-bezier(0.36, 0, 0.66, -0.56)' : 'cubic-bezier(0.34, 1.56, 0.64, 1)')}>
            <PhotoView src={dish.photo}>
              <div className="profile-photo m-0 ml-1"
                   style={{
                     backgroundImage: `url(${dish.photo})`,
                     height: 45, width: 45, minWidth: 45
                   }}
              />
            </PhotoView>
          </PhotoProvider>}
        { !dish.categoryPrice &&
          <Button className='ml-2 order-count'
                  onClick={() => handleDishCount(slug, dish, calculateCount(dish))}
                  style={{ color: storeAuth?.auth?.userData?.theme === 'dark' ? 'white' : '#130B01' }}
          >
            <strong>+</strong>
          </Button>}
      </div>
    </div>
  );
};

export default OrderDish;
